import {
  DATE_FORMAT_FULL_WEEK_DAY_FNS,
  DATE_FORMAT_RANGE_SHORT_FNS,
  DATE_FORMAT_TIME_FNS,
  DATE_FORMAT_WEEK_DAY_MID_FNS,
  SchoolRelation,
  WithAvatar,
} from '@schooly/api';
import { ThreadUser } from '@schooly/api';
import { DATE_FORMAT_SHORT_DAY_MONTH } from '@schooly/constants';
import { newDateTimezoneOffset } from '@schooly/utils/date';
import {
  format,
  isSameWeek,
  isSameYear,
  isThisWeek,
  isThisYear,
  isToday,
  isYesterday,
} from 'date-fns';
import { useIntl } from 'react-intl';
export function pickThreadUserProps<T extends SchoolRelation & WithAvatar & { user_id: string }>(
  user: T,
): ThreadUser {
  return {
    user_id: user.user_id,
    given_name: user.given_name ?? '',
    last_name: user.last_name,
    profile_picture: user.profile_picture ?? null,
    known_as: user.known_as ?? '',
    relation_id: user.relation_id,
  };
}

export function formatChannelDate(date: Date): string {
  if (isToday(date)) {
    return format(date, DATE_FORMAT_TIME_FNS);
  } else if (isThisWeek(date)) {
    return format(date, DATE_FORMAT_WEEK_DAY_MID_FNS).toUpperCase();
  } else if (isThisYear(date)) {
    return format(date, DATE_FORMAT_SHORT_DAY_MONTH);
  } else {
    return format(date, DATE_FORMAT_RANGE_SHORT_FNS);
  }
}

export const formatMessageDate = (date: Date): string => {
  const { formatMessage } = useIntl();

  if (isToday(date)) return formatMessage({ id: 'messages-ThreadChannelMessageToday' });
  if (isYesterday(date)) return formatMessage({ id: 'messages-ThreadChannelMessageYesterday' });
  if (isSameWeek(date, newDateTimezoneOffset(), { weekStartsOn: 1 })) {
    return format(date, DATE_FORMAT_FULL_WEEK_DAY_FNS);
  }
  if (isSameYear(date, newDateTimezoneOffset())) return format(date, DATE_FORMAT_SHORT_DAY_MONTH);

  return format(date, DATE_FORMAT_RANGE_SHORT_FNS);
};
